// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__SY4nA","slide":"loader_slide__O-QCk"};